import { render } from "./NotFound.vue?vue&type=template&id=d5c89692"
const script = {}

import exportComponent from "/opt/vue/ped/ped-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__